import { Outlet } from "react-router";

export function AppLayout() {
  return (
    <>
      <s-app-nav>
        <s-link href="/" rel="home">
          Dashboard
        </s-link>
        <s-link href="/campaigns">Campaigns</s-link>
        <s-link href="/analytics">Analytics</s-link>
        <s-link href="/settings">Settings</s-link>
      </s-app-nav>
      <div className="content">
        <Outlet />
      </div>
    </>
  );
}
